import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { setSelections } from 'redux/slices/selections';

import { selectionDataService } from 'services/selection.service';

import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { Modal } from 'components/Modal';

import * as S from './NewListModal.styles';

type NewListModalProps = {
  onClose: () => void;
};

const defaultProps: Partial<NewListModalProps> = {};

export function NewListModal(props: NewListModalProps): React.ReactElement {
  const { onClose } = { ...defaultProps, ...props };
  const { register, handleSubmit } = useForm();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { season, warehouse } = useAppSelector((state) => state.settings);

  const onSubmit = (data: FieldValues) => {
    selectionDataService
      .post(season, data.name, warehouse.code)
      .then(() => {
        toast.success(t('selection.listCreated'));

        selectionDataService.getAll(season, warehouse.code).then((res) => {
          dispatch(setSelections(res.data));
        });
        onClose();
      })
      .catch((err: unknown) => {
        const error = err as {
          response?: { status?: number; data?: { apierror?: { message?: string } } };
        };

        toast.error(
          error.response?.status === 400
            ? t('selection.duplicateListName')
            : error.response?.data?.apierror?.message || t('error.generic')
        );
      });
  };

  return (
    <Modal onClose={onClose}>
      <S.Container>
        <S.Title scale="xl2">{t('selection.addNewList')}</S.Title>

        <form onSubmit={handleSubmit(onSubmit)}>
          <S.InputWrapper>
            <Input
              scale="xs"
              motive="additionalSecondary"
              register={register}
              name="name"
              label={t('selection.nameOfList')}
              placeholder={t('selection.inputListName')}
            />
          </S.InputWrapper>

          <S.ButtonWrapper>
            <Button
              onClick={onClose}
              motive="cancelTertiary"
              fontFamily="LFT Zeno"
              textTransform="isFirstLetterUppercase"
            >
              {t('common.cancel')}
            </Button>

            <Button
              textTransform="isFirstLetterUppercase"
              fontWeight="light"
              fontFamily="LFT Zeno"
              type="submit"
              motive="actionTertiary"
            >
              {t('common.add')}
            </Button>
          </S.ButtonWrapper>
        </form>
      </S.Container>
    </Modal>
  );
}
